import { mapState } from "vuex";
export default {
	name: 'Watchers',
	data() {
		return {
			watch_zones: ['work', 'break', 'planning', 'muster', 'start', 'restricted']
		}
	},
	computed: {
		...mapState([
			"workers",
			"clock",
			"time",
			"day",
			"muster",
			"sprites",
			"watcher",
			"move_watcher",
			"worker_status",
			"position",
			"messages",
			"proximity"
		]),
		worker_types() { return this.$config.worker_types },
		drawLayer() { return this.$store.state.map.drawLayer },
		zones() { return this.$store.state.creator.zones },
		map() { return this.$store.state.map.map },
		alert: {
			get() { return this.$store.state.alert },
			set(value) {
				this.$store.commit('add_alert', value)
			}
		},
		muster() { return this.$store.state.muster }
	},
	watch: {
		day: {
			handler() {
				if (this.watcher[this.day] == undefined) {
					this.$set(this.watcher, this.day, {});
					this.$set(this.move_watcher, this.day, {});
					for (let i in this.workers) {
						let worker = this.workers[i];
						let watcher = this.watcher[this.day];
						if (watcher[worker.id] == undefined) {
							this.$set(watcher, worker.id, []);
							this.$set(this.move_watcher[this.day], worker.id, []);
						}
					}
				}
				for (let i in this.workers) {
					let worker = this.workers[i];
					if (this.position[worker.id][this.day] == undefined) {
						this.$set(this.position[worker.id], this.day, []);
					}
				}
			},
			immediate: true
		},
		workers: {
			handler() {
				for (let i in this.workers) {
					let worker = this.workers[i];
					let watcher = this.watcher[this.day];
					if (watcher[worker.id] == undefined) {
						this.$set(watcher, worker.id, []);
						this.$set(this.move_watcher[this.day], worker.id, []);
						this.$set(this.position, worker.id, {});
						this.$set(this.position[worker.id], this.day, []);
					}
					if (this.worker_status[worker.id] == undefined) {
						this.$set(this.worker_status, worker.id, { 'id': worker.id, zone_id: null, status: null, destination: [0, 0] })
					}
					if (this.worker_status[worker.id].status != worker.status || (this.worker_status[worker.id].destination && worker.destination && (this.worker_status[worker.id].destination[0] != worker.destination[0] || this.worker_status[worker.id].destination[1] != worker.destination[1]))) this.workerEvent(worker);
				}
			},
			deep: true
		},
		time() {
			for (let i in this.workers) {
				let worker = this.workers[i];
				this.watchExit(worker);
			}
		}
	},
	methods: {

		workerEvent(worker) {

			let watcher = this.watcher[this.day][worker.id];
			let move_watcher = this.move_watcher[this.day][worker.id];
			let worker_status = this.worker_status[worker.id];
			worker_status.status = worker.status;

			if (worker.status == 'going' && worker_status.traveling != true) {
				let report = 'yes';
				watcher.push({ type: 'travel', path: worker.path, time: this.time, day: this.day, clock: this.clock, label: "is traveling to", class_type: "primary", zone_id: worker.zone.id, target_zone_id: worker.target_zone_id, travel_time: 0, report: report });
				worker_status.traveling = true;
			}

			if (worker.status == 'at-zone') {
				if (worker_status.traveling == true) {
					let log = false;

					for (var i = watcher.length - 1; i >= 0; --i) {
						if (watcher[i].type == 'travel' && worker.zone.id == watcher[i].target_zone_id) {
							log = watcher[i];
							break;
						}
					}
					if (log != false) {
						log.travel_time = this.time - log.time;
						Object.freeze(log);
					}
					worker_status.traveling = false;
				}

				if (worker.zone.id != worker_status.zone_id) {
					let alert = 0;
					let class_type = 'success';
					let zone = worker.zone;

					worker_status.zone_id = zone.id;
					if (zone.type == 'restricted') {
						alert = 1;
						class_type = 'danger';
					}
					else if (zone.type == 'break') {
						alert = 2;
						class_type = 'warning';
					}

					watcher.push(Object.freeze({ type: 'entry', zone_id: worker_status.zone_id, time: this.time, day: this.day, clock: this.clock, label: 'enters', alert: alert, class_type: class_type, muster: this.muster }));

					if (zone.type == 'planning' && this.messages[worker.id]) {
						let messages = this.$finder.all({type: 'planning', 'status': 'going'}, this.messages[worker.id]);
						for (let i in messages) {
							let message = messages[i];
							message.response = {value: 'Asset {{name}} arrived at planning zone.', day: this.day, time: this.time};
							message.status = 'arrived';
						}
					}

				}
				else if (worker.destination && (worker_status.destination[0] != worker.destination[0] || worker_status.destination[1] != worker.destination[1])) {

					move_watcher.push(Object.freeze({ type: 'move', zone_id: worker.zone.id, time: this.time, day: this.day, clock: this.clock, label: 'moved within', class_type: 'light', muster: this.muster, destination: worker.destination, report: 'no' }));
					worker_status.destination = worker.destination;
				}


			}

			if (worker.status == 'injury' && worker_status.reported != true) {
				if (worker.injury == 'fall') watcher.push(Object.freeze({ type: 'fall', zone_id: worker_status.zone_id, time: this.time, day: this.day, clock: this.clock, label: 'fell from height at', alert: 1, class_type: 'danger' }));
				else watcher.push(Object.freeze({ type: 'man-down', zone_id: worker_status.zone_id, time: this.time, day: this.day, clock: this.clock, label: 'is down at', alert: 1, class_type: 'danger' }));
				worker_status.reported = true;
			}
		},
		watchExit(worker) {
			const watcher = this.watcher[this.day][worker.id];
			const worker_status = this.worker_status[worker.id];
			if (worker_status.traveling != true) return;

			const $sprite = this.sprites[worker.id];
			const position = $sprite.getCoordinate();
			const features = this.drawLayer.getFeaturesAtCoordinate(position);

			// Track check-in/check-out events
			const boundary = this.drawLayer.getFeaturesAtCoordinate(position).find(f => f.type == 'boundary');
			if (!worker.check_in) {
				if (boundary) {
					worker.check_in = true;
					watcher.push(Object.freeze({ type: 'check-in', time: this.time, day: this.day, clock: this.clock, label: 'checked in', class_type: 'secondary' }));
				}
			}
			else {
				if (!boundary) {
					worker.check_in = false;
					watcher.push(Object.freeze({ type: 'check-out', time: this.time, day: this.day, clock: this.clock, label: 'checked out', class_type: 'secondary' }));
				}
			}

			let exit = false;
			for (var i in features) {
				let feature = features[i];
				if (this.watch_zones.indexOf(feature.type) == -1) continue;

				if (worker_status.zone_id && worker_status.zone_id != feature.id && feature.floor_level == worker.floor_level) {
					exit = true;
					let report = (worker.zone.type == 'travel') ? false : true;
					if (report) watcher.push(Object.freeze({ type: 'exit', zone_id: worker_status.zone_id, time: this.time, day: this.day, clock: this.clock, class_type: 'info', label: 'left' }));
					worker_status.zone_id = null;
				}
			}

			if (features.length == 0 && worker_status.zone_id && !exit) {
				let report = (worker.zone.type == 'travel') ? false : true;
				if (report) watcher.push(Object.freeze({ type: 'exit', zone_id: worker_status.zone_id, time: this.time, day: this.day, clock: this.clock, label: 'leaves', class_type: 'info' }));
				worker_status.zone_id = null;
			}
		}
	}
}
